import { ENVIRONMENT } from '@app/configs/host';

import { OrganizationEntityCodes } from '@shared/types/types';

import { NCALayerClient } from './ncalayer-client';

type SignatureOptions = NcaLayerSignatureOptions;

export const signersObject: Record<OrganizationEntityCodes, object> = {
    IndividualEntrepreneurJoint: NCALayerClient.basicsSignerSignOrg,
    IndividualEntrepreneurPersonal: NCALayerClient.basicsSignerSignPerson,
    Legal: NCALayerClient.basicsSignerSignOrg,
    Physical: NCALayerClient.basicsSignerSignPerson,
    Other: NCALayerClient.basicsSignerAny,
    OtherPhysical: NCALayerClient.basicsSignerAny,
};

export default async function getSignature(
    base64: string,
    options?: SignatureOptions,
) {
    return getNcaLayerSignature(base64, options);
}

export const getDigitalId = () => {
    const text = 'SIGN_FOR_CITY_PORTAL';
    const encodedText = btoa(text);
    return encodedText;
};

export interface NcaLayerSignatureOptions {
    signerParams?: object;
    locale?: string;
}

export async function getNcaLayerSignature(
    base64: string,
    options?: NcaLayerSignatureOptions,
): Promise<string> {
    const ncaLayerClient = new NCALayerClient();

    await ncaLayerClient.connect();
    const base64EncodedSignature = await ncaLayerClient.basicsSignCMS(
        NCALayerClient.basicsStorageAll,
        base64,
        NCALayerClient.basicsCMSParamsDetached,
        ENVIRONMENT === 'PROD'
            ? options?.signerParams || NCALayerClient.basicsSignerSignAny
            : NCALayerClient.basicsSignerTestAny,
        options?.locale,
    );
    if (Array.isArray(base64EncodedSignature)) return base64EncodedSignature[0];
    return base64EncodedSignature.toString();
}

export async function getSignatureInfo(): Promise<object> {
    const ncaLayerClient = new NCALayerClient();

    await ncaLayerClient.connect();
    const base64EncodedSignature = await ncaLayerClient.getKeyInfo(
        NCALayerClient.basicsStoragePKCS12[0],
    );
    return base64EncodedSignature;
}
